const NAME_ERROR_CODES = [
    "PERIMETER_NAME_REQUIRED",
    "PERIMETER_NAME_TOO_LONG",
    "PERIMETER_NAME_TAKEN",
];

// The perimeter changed or vanished since the list was loaded: the screen has
// to reload rather than let the user retry on outdated data.
const STALE_PERIMETER_ERROR_CODES = [
    "PERIMETER_MEMBER_INVALID",
    "PERIMETER_MEMBER_NOT_RESTRICTABLE",
    "MEMBER_NOT_FOUND",
    "INVALID_PERIMETER_ID",
    "PERIMETER_NOT_FOUND",
    "PERIMETER_ARCHIVED",
    "PERIMETER_NOT_ARCHIVED",
    "PERIMETER_IN_USE",
    "PERIMETER_TRANSFER_INVALID",
];

const ERROR_KEYS = {
    PERIMETER_NAME_REQUIRED: "perimeters.errors.nameRequired",
    PERIMETER_NAME_TOO_LONG: "perimeters.errors.nameTooLong",
    PERIMETER_NAME_TAKEN: "perimeters.errors.nameTaken",
    PERIMETER_MEMBER_INVALID: "perimeters.errors.memberInvalid",
    PERIMETER_MEMBER_NOT_RESTRICTABLE: "perimeters.errors.memberInvalid",
    MEMBER_NOT_FOUND: "perimeters.errors.memberInvalid",
    INVALID_PERIMETER_ID: "perimeters.errors.notFound",
    PERIMETER_NOT_FOUND: "perimeters.errors.notFound",
    PERIMETER_ARCHIVED: "perimeters.errors.archived",
    PERIMETER_NOT_ARCHIVED: "perimeters.errors.notArchived",
    PERIMETER_IN_USE: "perimeters.errors.inUse",
    PERIMETER_TRANSFER_INVALID: "perimeters.errors.transferInvalid",
    PERIMETER_FORBIDDEN: "perimeters.list.forbidden",
    COMPANY_ACCESS_DENIED: "perimeters.list.forbidden",
};

const getErrorCode = (err) => err?.response?.data?.errorCode;

// Name errors are shown under the name field, every other one in a toast.
export const isNameError = (err) =>
    NAME_ERROR_CODES.includes(getErrorCode(err));

export const isStalePerimeterError = (err) =>
    STALE_PERIMETER_ERROR_CODES.includes(getErrorCode(err));

// Archiving or deleting an already archived perimeter: the default wording
// tells to restore it before editing, which does not fit there.
export const ARCHIVE_ERROR_OVERRIDES = {
    PERIMETER_ARCHIVED: "perimeters.errors.alreadyArchived",
};

// `overrides` maps an error code to another message key.
export const getPerimeterErrorMessage = (language, err, overrides = {}) => {
    const code = getErrorCode(err);
    return language.getValue(
        overrides[code] || ERROR_KEYS[code] || "perimeters.errors.generic"
    );
};
